import { AllocationViewActionsFacade } from '../allocation-view-actions.facade';
import { AllocationViewFinishDepartureSecurityModel, AllocationViewSelectedEntityModel } from '../../models';
import { AllocationViewActionInterface } from '../models';
import { filter, take } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import {
  AllocationViewFinishDepartureSecurityAction,
  AllocationViewFinishDepartureSecurityActionPrepare,
  AllocationViewFinishDepartureSecurityActionSetInitialState,
} from './allocation-view-finish-departure-security-action.actions';
import { AllocationViewFinishDepartureSecurityActionState } from './allocation-view-finish-departure-security-action.state';

@Injectable({ providedIn: 'root' })
export class AllocationViewFinishDepartureSecurityActionFacade implements AllocationViewActionInterface {
  loaded$: Observable<boolean> = this.store.select(AllocationViewFinishDepartureSecurityActionState.getLoaded);
  preparedDetails$: Observable<AllocationViewFinishDepartureSecurityModel> = this.store.select(
    AllocationViewFinishDepartureSecurityActionState.getPreparedDetails,
  );

  constructor(
    private allocationViewActionsFacade: AllocationViewActionsFacade,
    private translateService: TranslateService,
    private store: Store,
  ) {}

  departureSecurityFinish(dock: AllocationViewFinishDepartureSecurityModel): void {
    this.allocationViewActionsFacade.actionIdentifier$.pipe(filter(Boolean), take(1)).subscribe(() => {
      this.store.dispatch(new AllocationViewFinishDepartureSecurityAction(dock));
    });
  }

  loadAll(): void {
    this.allocationViewActionsFacade.actionIdentifier$
      .pipe(filter(Boolean), take(1))
      .subscribe(({ identifier }: AllocationViewSelectedEntityModel) => {
        this.store.dispatch(
          new AllocationViewFinishDepartureSecurityActionPrepare(identifier, this.translateService.currentLang),
        );
      });
  }

  setInitialState(): void {
    this.store.dispatch(new AllocationViewFinishDepartureSecurityActionSetInitialState());
  }
}
